// This can be replaced with MUI's NoSsr component, there's no need to support this if we can use theirs

import * as React from "react"
import { Box } from "@mui/material"

function ClientOnly({ children, ...props }) {
  const [hasMounted, setHasMounted] = React.useState(false)
  React.useEffect(() => {
    setHasMounted(true)
  }, [])
  if (!hasMounted) {
    return null
  }
  return <Box {...props}>{children}</Box>
}

export default ClientOnly
